
import { Component, Vue } from 'vue-property-decorator';
import { ServerInterface, ServerRepositoryInterface } from '@/services/Server/Interfaces';
import { ServerStatus } from '@/services/Server';
import { AxiosError } from 'axios';
import PageHeader from '@/components/layout/PageHeader.vue';
import StatusChip from '@/components/layout/StatusChip.vue';

@Component({
  components: {
    PageHeader,
    StatusChip,
  },
  inject: [
    'serverRepository',
  ],
})
export default class ViewServer extends Vue {
  public loading = true;
  public readonly serverRepository!: ServerRepositoryInterface;
  public server: ServerInterface = {} as ServerInterface;
  public statusDraft = '';
  public serverStatuses = [
    { text: 'UP', value: 'Up' },
    { text: 'DOWN', value: 'Down' },
  ];

  public async mounted(): Promise<void> {
    await this.initialize();
  }

  public async initialize(): Promise<void> {
    try {
      this.server = await this.serverRepository.getServer(this.$route.params.server);
      this.statusDraft = this.server.status;
      this.loading = false;
    } catch (e) {
      this.$errorDialog.show((e as AxiosError)?.response?.data?.message || (e as Error).message);
    }
  }

  public async changeServerStatus(status: string): Promise<void> {
    if (status === this.server.status) {
      return;
    }

    try {
      await this.serverRepository.updateServerStatus(this.server.hostname, status);
      this.server.status = status === 'Up' ? ServerStatus.Up : ServerStatus.Down;
      this.statusDraft = this.server.status;
      this.$successDialog.show('Server Status Updated!');
    } catch (e) {
      this.statusDraft = this.server.status;
      this.$errorDialog.show((e as AxiosError)?.response?.data?.message || (e as Error).message);
    }
  }
}
